<template>
	<div class="container" :class="{ 'no-heading-image': !page.headingImage }">
		<Html :lang="locale" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<navigation />

		<slot />

		<!-- <breadcrumbs
			v-if="page && page.slug != 'index'"
			:breadcrumbs="page.breadcrumbs"
			:home="defaults[locale].website.restaurantName"
		/> -->
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
		<footers />

		<pop-up
			v-if="page && defaults[locale].popUp.content"
			:image="defaults[locale].popUp.image"
			:content="defaults[locale].popUp.content"
		/>
		<to-top />
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

await fetchPage();
await fetchDefaults();

const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.fix-on-scroll');
	if (window.scrollY >= 50) {
		fixedElements.forEach((el) => el.classList.add('fixed'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('fixed'));
	}
};

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.hotelName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.hotelName || '',
	});

	useHead({
		script: [
			{
				defer: true,
				'data-assistant': '67b5cf700c1d9d80d4c5366c',
				src: 'https://hiring-assistant.soigne.app/sdk.js',
			},
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@type': 'Restaurant',
					'@id': `${config.public.siteUrl}#restaurant`,
					image: website.structuredImage,
					url: config.public.siteUrl,
					name: website.restaurantName,
					logo: `${config.public.siteUrl}/images/logo-dinette-color.png`,
					telephone: website.phone,
					email: website.email,
					address: {
						'@type': 'PostalAddress',
						streetAddress: `${website.street} ${website.number}, ${website.city}`,
						postalCode: website.postalCode,
					},
				}),
			},
			{
				src: 'https://live.tebi.co/ecom/widget-manager.js',
				id: 'tebi',
				'data-widget-token': '949100_0330432343f77d1c21f9e1fba4e71b3f23a3f1306fdb93318bc0d770bc2a93b7',
			},
		],
	});
}
</script>
